import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/shared.module';
import { MaterialModule } from '../../../../../shared/material.module';
import { CsvFileUploadModule } from '../csv-file-upload/csv-file-upload.module';
import { AddStaffWrapperComponent } from './add-staff-wrapper.component';



@NgModule({
  declarations: [
    AddStaffWrapperComponent
  ],
  exports: [
    AddStaffWrapperComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    CsvFileUploadModule
  ]
})
export class AddStaffWrapperModule { }
